import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://aefwnneuyqrlmwanetjh.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImFlZndubmV1eXFybG13YW5ldGpoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU3NzE1MzgsImV4cCI6MjA4MTM0NzUzOH0.J-cpP_gyZvFiLGY9MN4w3KNHpq1Jvc7CveZUaqwXjX8';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);